import { useState, useEffect,useContext } from "react";
import { useLocation } from "react-router-dom";
import { RiCloseLargeFill } from "react-icons/ri";
import logoImg from "../../assets/images/kplot-logo-white.png";
import { toast } from "react-toastify";
import axios from 'axios';
import { baseURL } from '../axiosInterceptor/axiosInterceptorC';
import { LoginPopupContext } from '../loginpopup/LoginPopupContext';
import { RoleContext } from '../pages/Userdatacontext/Datacontexts'; 
import { fetchUserDetails,setTokengen } from '../slice/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import "react-toastify/dist/ReactToastify.css";

function Login({onClose, setIsSaved }) {
    const location = useLocation();
    const dispatch = useDispatch();
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        otp: "",
    });

    const [isPopupVisible, setIsPopupVisible] = useContext(LoginPopupContext);
    const [fetchPropertyDetails, setFetchPropertyDetails] = useState(null); 
    const [showOtpInput, setShowOtpInput] = useState(false);
    const [showOtpGroup, setShowOtpGroup] = useState(false);
    const [timer, setTimer] = useState(60);
    const [isTimerRunning, setIsTimerRunning] = useState(false);
    const [showResendBtn, setShowResendBtn] = useState(false);
    const [isFormBtnEnabled, setIsFormBtnEnabled] = useState(false);
    const [isRolePopupVisible, setIsRolePopupVisible] = useState(false);
    const [selectedRole, setSelectedRole] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    const [generatedOtp, setGeneratedOtp] = useState(null); // To hold the generated OTP

    const { data, fetchpropertydetails, updateRole, settokenval } = useContext(RoleContext);

    // Handle name input (only letters and spaces)
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "name") {
            const cleanedValue = value.replace(/[^a-zA-Z\s]/g, "");
            setFormData({ ...formData, [name]: cleanedValue });
        }
    };

    // Handle phone input (only numbers)
    const handlePhoneChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData({ ...formData, [name]: value });
        }
    };

    // Handle OTP input and enable form button
    const handleOtpChange = (e) => {
        const otp = e.target.value;
        if (/^\d*$/.test(otp) && otp.length <= 6) {
            setFormData({ ...formData, otp });
            setIsFormBtnEnabled(otp.length === 6);
        }
    };

    useEffect(() => {
        // Toggle body overflow when popup visibility changes
        if (isPopupVisible) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }

        // Cleanup on component unmount
        return () => {
            document.body.style.overflow = "inherit";
        };
    }, [isPopupVisible]);

    // close login form popup
    const handleClosePopup = () => {
        setFormData({
            name: "",
            phone: "",
            otp: "",
            loginType: "",
        });
        setShowOtpInput(false);
        setShowOtpGroup(false);
        setIsTimerRunning(false);
        setTimer(60);
        setShowResendBtn(false);
        setGeneratedOtp(null);
        setIsFormBtnEnabled(false);
        onClose(); // Call parent close handler
        const previousAction = localStorage.getItem("previousAction");
                if (previousAction) {
                    localStorage.removeItem("previousAction");
                }
    };

    // Generate and send OTP
    const handleGetOtp = async() => {
        if (!formData.phone || formData.phone.length < 10) {
            toast.error("Please enter a valid phone number.");
            return;
        }

        try {
            const response=await axios.post(`${baseURL}/check_user_exist_not`,{
                phone_number:formData.phone,
            })
            console.log(response.data)
            if(response.data.success==true){
            const otp = Math.floor(100000 + Math.random() * 900000); // Generate 6-digit OTP
            setGeneratedOtp(otp);
            toast.success(response.data.message); // Mocked OTP for testing
            //send_otp_function(formData.phone,otp)
            
            setShowOtpGroup(true);
            setShowOtpInput(true);
            setIsTimerRunning(true);
            setTimer(60);
            setShowResendBtn(false);
            setIsFormBtnEnabled(false);
            }
            else{
                toast.error(response.data.message)
            }
        }
        catch (error) {
                
        }
        
    };

    const send_otp_function=async(phone_number,otp_val)=>{
        try {
            const response=await axios.post(`${baseURL}/send_otp_function`,{
                phone_number:phone_number,
                otp_val:otp_val
            })
            //console.log(response.data)
        } catch (error) {
            
        }
    }

    const send_otp_registration=async(name_val,phone_number)=>{
        try {
            const response=await axios.post(`${baseURL}/send_otp_registration`,{
                phone_number:phone_number,
                name_val:name_val
            })
            //console.log(response.data)
        } catch (error) {
            
        }
    }

    // Resend OTP logic
    const handleResendOtp = () => {
        const otp = Math.floor(100000 + Math.random() * 900000); // Generate new OTP
        setGeneratedOtp(otp);
        //send_otp_function(formData.phone,otp)
        toast.info(`Resented OTP to your phone`); // Mocked OTP for testing
        console.log(otp)
        setTimer(60);
        setIsTimerRunning(true);
        setShowResendBtn(false);
    };

    // Timer countdown effect
    useEffect(() => {
        let countdown;
        if (isTimerRunning) {
            countdown = setInterval(() => {
                setTimer((prev) => {
                    if (prev <= 1) {
                        clearInterval(countdown);
                        setIsTimerRunning(false);
                        setShowResendBtn(true);
                        setGeneratedOtp(null); // Invalidate OTP
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }
        return () => clearInterval(countdown);
    }, [isTimerRunning]);


    const { userDetails,gettokenval } = useSelector(
        (state) => state.user
      );

      const login_id = localStorage.getItem('login_id');
      
      useEffect(() => {
          if (login_id) {
              dispatch(fetchUserDetails(login_id));
          }
      }, [dispatch, login_id]);
      
      useEffect(() => {
          if (userDetails && userDetails.role_val !== undefined) {
              setIsRolePopupVisible(!userDetails.role_val);
          }
      }, [userDetails]); 
      

    // Handle OTP submission
    const handleOtpSubmit = async () => {
        if (!generatedOtp) {
            toast.error("OTP has expired. Please resend OTP.");
            return;
        }
        localStorage.setItem("fetchProperty", "true");
        try {
            const response = await axios.post(`${baseURL}/loginactiondata`, {
                mobile: formData.phone,
                name_val: formData.name,
                otp: formData.otp,
            });
    
            console.log(response.data)
            
           // if (formData.otp ==generatedOtp) {
            if (formData.otp =='123456') {
                localStorage.setItem("jwtToken", response.data.token);
                localStorage.setItem("login_id", response.data.loginId);
                localStorage.setItem("roleval", response.data.role_val);
                localStorage.setItem("districtval", response.data.districtval);
                updateRole(response.data.role_val);
                settokenval(response.data.token);
                dispatch(setTokengen(response.data.token));  
                fetchStoressessionvalues(response.data.loginId);
                toast.success("OTP validation successful!");
                if(response.data.userstatus=='new'){
                    setIsRolePopupVisible(true)
                    //send_otp_registration(formData.name,formData.phone)
                }
                else{
                    setIsRolePopupVisible(false)
                }

                setFormData({ name: "", phone: "", otp: "", loginType: "" });
                setShowOtpGroup(false);  // Hide OTP group
                setTimer(0);             // Reset timer
                setShowOtpInput(false);
                let shouldFetchPropertyDetails = false;
                const previousAction = localStorage.getItem("previousAction");
                if (previousAction) {
                    const { action, data } = JSON.parse(previousAction);
                    if (action === "handleSaveClick") {
                        await axios.post(
                            `${baseURL}/addpropertywishlist`,
                            { ...data, login_id: response.data.loginId },
                            { headers: { Authorization: `Bearer ${response.data.token}` } }
                        );
    
                        toast.success("Property saved successfully!");
                        shouldFetchPropertyDetails = true;
                    }else if(action === "PostProperty"){
                        const previousAction = JSON.parse(localStorage.getItem("previousAction"));
                        // Check if the URL exists in the data section
                        if (previousAction && previousAction.data && previousAction.data.url) {
                            window.location.href = previousAction.data.url; // Redirect to the stored URL
                        } else {
                            console.error("No valid URL found in localStorage.");
                        }
                    }
    
                    const isPropertiesPage = location.pathname === "/keralaplots/properties";
                    const isBuilderPage = /^\/keralaplots\/[^/]+\/builderPropertyList$/.test(location.pathname);

                    if ((isPropertiesPage || isBuilderPage)) {
                        window.location.reload();
                    }
                    localStorage.removeItem("previousAction");
                }
                onClose();
                console.log("Befor shouldFetchPropertyDetails ")
                if (shouldFetchPropertyDetails) {
                    setIsLoading(true);
                    console.log("After shouldFetchPropertyDetails ")
                    await fetchpropertydetails(); // ✅ Ensure fresh data
                    window.dispatchEvent(new Event("propertyUpdated")); // ✅ Notify PropertyList
                }
            } else {
                toast.error("Invalid OTP. Please try again.");
            }
        } catch (error) {
            toast.error(error.response?.data?.error || "An error occurred. Please try again.");
        }
    };
    

    const fetchStoressessionvalues = async (loginId) => {
        console.log("User login ID: " + loginId);
        try {
            const response = await axios.post(
                'https://keralaplots.com/Official/create_session.php',
                { loginId: loginId },
                {
                    headers: {
                        'Content-Type': 'application/json', // Ensure the server knows you're sending JSON
                    },
                    withCredentials: true, // Include cookies in the request
                }
            );
            console.log(response.data);  // Log the response from the server
        } catch (error) {
            toast.error(error.response?.data?.error || "An error occurred. Please try again.");
        }
    };
    
    


    const handleRoleChange = (event) => {
        setSelectedRole(event.target.value);
    };

    
    

    const handleSubmit = async (event) => {
        event.preventDefault();
        const login_id1=localStorage.getItem('login_id');
        setIsRolePopupVisible(false);
        localStorage.setItem('roleval', selectedRole);
        //window.location.reload();
        try {
            const response = await axios.post(`${baseURL}/updateprofile`, {
                login_id: login_id1,
                role_val:selectedRole,
            });
            updateRole(selectedRole)
            dispatch(fetchUserDetails(login_id1));
       }
         catch (error) {
        //toast.error(error.response?.data?.error || "An error occurred. Please try again.");
    }
       
    };
   
    return (
        <>
            {isPopupVisible && (
                <div className="loginPopup">
                    <div className="loginPopupBox">
                        <div className="closeLoginPopup" onClick={handleClosePopup}>
                            <RiCloseLargeFill />
                        </div>
                        <div className="loginPopupBoxHead">
                            <div className="loginPopupLogo">
                                <img src={logoImg} alt="logo" />
                            </div>
                        </div>
                        <div className="loginPopupBoxBody">
                            <form>
                                <h2>Login Now</h2>
                                <div className="formGroup">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Enter Name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                </div>
                                <div className="formGroup">
                                    <label>Phone Number</label>
                                    <input
                                        type="text"
                                        name="phone"
                                        placeholder="Enter Phone Number"
                                        maxLength="10"
                                        value={formData.phone}
                                        onChange={handlePhoneChange}
                                    />
                                </div>
                                

                                {/* Get OTP Button */}
                                <div className="formOtpInput">
                                    {!showOtpInput && (
                                        <div className="getOtpBtn" onClick={handleGetOtp}>
                                            Get OTP
                                        </div>
                                    )}

                                    {/* OTP Input Group */}
                                    {showOtpGroup && (
                                        <div className="formOtpInputGroup">
                                            <label>Enter OTP</label>
                                            <div className="formOtpInputBox">
                                                <input
                                                    type="text"
                                                    placeholder="000000"
                                                    maxLength="6"
                                                    value={formData.otp}
                                                    onChange={handleOtpChange}
                                                />
                                                <div className="otpTimer">
                                                    {timer > 0 ? `${timer}s` : "Time's up!"}
                                                </div>
                                                {showResendBtn && (
                                                    <div
                                                        className="resendOtpBtn"
                                                        onClick={handleResendOtp}
                                                    >
                                                        Resend OTP
                                                    </div>
                                                )}
                                                <div className="otpExpaireAlert">
                                                    {!generatedOtp && (
                                                        <span>OTP has expired. Please click "Resend OTP" to receive a new one.</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* Continue Button */}
                                {showOtpGroup && (
                                    <div className="formBtnArea">
                                        <button
                                            type="button"
                                            disabled={!isFormBtnEnabled || !generatedOtp}
                                            onClick={handleOtpSubmit}
                                        >
                                            Continue
                                        </button>
                                    </div>
                                )}
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* role popup */}
            {isRolePopupVisible && (
            <div className="rolePopup">
                <div className="rolePopupBox">
                    <div className="rolePopupBoxHead">
                        <div className="rolePopupLogo">
                            <img src={logoImg} alt="logo" />
                        </div>
                    </div>
                    <div className="rolePopupBoxBody">
                        <form onSubmit={handleSubmit}>
                            <h2>Choose Role</h2>
                            <div className="formGroup">
                                <label>Login as a</label>
                                <div className="formRadioBtn">
                                    <div className="formRadioBtnBox">
                                        <input type="radio" id="user" name="loginType" value="user" onChange={handleRoleChange} />
                                        <label htmlFor="user">User</label>
                                    </div>
                                    <div className="formRadioBtnBox">
                                        <input type="radio" id="agent" name="loginType" value="Agent" onChange={handleRoleChange} />
                                        <label htmlFor="agent">Agent</label>
                                    </div>
                                    <div className="formRadioBtnBox">
                                        <input type="radio" id="builder" name="loginType" value="Builder" onChange={handleRoleChange} />
                                        <label htmlFor="builder">Builder</label>
                                    </div>
                                </div>
                            </div>
                            <div className="formBtnArea">
                                <button className="submitRoleBtn" type="submit" disabled={!selectedRole}>Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            )}
            {/* role popup close */}
        </>
    );
}

export default Login;
